<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <h2 class="left">{{offer?.id ? "Modifica" : "Nuova"}} offerta</h2>
    <button class="btn btn-red right" id="deleteOffer" (click)="delete()" *ngIf="offer?.id && groups.includes('admin')">
      Elimina<i class="ml-10 far fa-trash-alt"></i>
    </button>
    <br class="clear">
  </div>
</section>

<section id="modificaConsegna" class="content-padding">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="_offerForm" (ngSubmit)="onSubmit()" *ngIf="_offerForm">
      <div class="grid-element-full">
        <label>Titolo{{ _offerForm.get("name") | required }}</label>
        <input type="text" formControlName="name">
        <app-error-html-handler [ctrl]="_offerForm.get('name')" [messages]="formValidationMsgs.name">
        </app-error-html-handler>
      </div>
      <div class="grid-element-full">
        <label>Descrizione{{ _offerForm.get("description") | required }}</label>
        <textarea formControlName="description" rows="5" placeholder="Scrivi una descrizione"></textarea>
      </div>
      <div class="col-48 grid-element">
        <label>Data pubblicazione{{ _offerForm.get("fromDate") | required }}</label>
        <input type="date" formControlName="fromDate">
        <app-error-html-handler [ctrl]="_offerForm.get('fromDate')" [messages]="formValidationMsgs.fromDate">
        </app-error-html-handler>
      </div>
      <div class="col-48 grid-element">
        <label>Data scadenza{{ _offerForm.get("toDate") | required }}</label>
        <input type="date" formControlName="toDate">
        <app-error-html-handler [ctrl]="_offerForm.get('toDate')" [messages]="formValidationMsgs.toDate">
        </app-error-html-handler>
      </div>
      <div class="col-48 grid-element">
        <label>Opzioni</label>
        <label class="original-label mt-5 mb-5">
          <input type="checkbox" formControlName="timeOffer" value="1">
          Offerta a tempo
        </label>
        <label class="original-label mt-5 mb-5">
          <input type="checkbox" formControlName="tryAndBuy" value="1">
          Try & Buy
        </label>
      </div>
      <div class="col-48 grid-element">
        <label>Stato{{ _offerForm.get("status") | required }}</label>
        <select formControlName="status">
          <option *ngFor="let item of offerStatus | enumToArray" value="{{item.name}}">
            {{offerStatusAux.ln('it', item.name)}}
          </option>
        </select>
        <app-error-html-handler [ctrl]="_offerForm.get('status')" [messages]="formValidationMsgs.status">
        </app-error-html-handler>
      </div>
      <div class="grid-element-full">
        <label>Prodotto{{ _offerForm.get('products').controls[0].get('id') | required }}</label>
        <div formArrayName="products">
          <div class="offer-products" *ngFor="let productForm of _offerForm.get('products').controls; let i = index">
            <div [formGroupName]="i" class="mb-5" style="display: table; width: 100%;">
              <!-- <input type="text" formControlName="name"> -->
              <div style="display: table-cell; width: 19px; vertical-align: middle;">
                <i class="far fa-times-circle hvr-grow remove-product" (click)="removeProduct(i)"></i>
              </div>
              <div style="display: table-cell;">
                <ng-select [items]="products" bindLabel="name" bindValue="id" formControlName="id">
                </ng-select>
              </div>
              <app-error-html-handler [ctrl]="productForm.get('id')" [messages]="formValidationMsgs.products.id">
              </app-error-html-handler>
            </div>
          </div>
        </div>
        <div class="center" style="width: 100%;">
          <button class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
            Aggiungi prodotto<i class="ml-10 fas fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="grid-element-full">
        <label>Note{{ _offerForm.get("notes") | required }}</label>
        <textarea formControlName="notes" rows="5" placeholder="Scrivi una nota"></textarea>
      </div>
      <br class="clear">
      <div class="center">
        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()"
          [disabled]="!_offerForm?.valid">
          Salva<i class="ml-10 far fa-save"></i>
        </button>
      </div>
    </form>
    <br class="clear">
  </div>
</section>
